import React from 'react';
import { motion } from 'framer-motion';
export function PriceSection() {
  return <section className="py-20 px-4 bg-navy-800/30 border-y border-navy-800 relative" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-67">
          <h2 className="font-heading text-3xl sm:text-4xl text-white mb-8" data-id="element-68">
            Por qué <span className="text-amber-400" data-id="element-69">$6.36</span>
          </h2>

          <div className="relative" data-id="element-70">
            {/* Large quote marks for visual interest */}
            <span className="absolute -top-8 -left-4 text-6xl text-navy-800 font-heading select-none" data-id="element-71">
              "
            </span>

            <p className="text-lg sm:text-xl text-slate-300 leading-relaxed relative z-10" data-id="element-72">
              Muchos me preguntan por qué vendo este protocolo por el{' '}
              <span className="text-amber-400 font-medium" data-id="element-73">
                precio de un café
              </span>
              . La respuesta es simple: Quiero que el precio sea una
              no-objeción.
              <br data-id="element-74" />
              <br data-id="element-75" />
              Quiero que experimentes la diferencia de despertar con energía
              real, para que en el futuro confíes en mis soluciones más
              avanzadas.{' '}
              <span className="text-white font-medium" data-id="element-76">
                Es un trato en el que ambos ganamos.
              </span>
            </p>

            <span className="absolute -bottom-12 -right-4 text-6xl text-navy-800 font-heading select-none rotate-180" data-id="element-77">
              "
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}